import { render, staticRenderFns } from "./AuthUpload.vue?vue&type=template&id=4ed08758&scoped=true"
import script from "./AuthUpload.vue?vue&type=script&lang=js"
export * from "./AuthUpload.vue?vue&type=script&lang=js"
import style0 from "./AuthUpload.vue?vue&type=style&index=0&id=4ed08758&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ed08758",
  null
  
)

export default component.exports